import { ILanguageDictionary } from './keys';
import en from './translations/en-RU';
import ru from './translations/ru-RU';

export type SupportedLanguages = "ru" | "en";
export const LANG_RESOURCES: ILanguageDictionary = { en, ru };
export const DEFAULT_LANGUAGE: SupportedLanguages = 'ru'; 